import axios from 'axios'
var updateMember = {
  methods: {
    // 更新會員資料
    updateMember () {
      if (!this.authorized || !this.isUpdatedMember) return
      let data = {
        // ...this.shoppingInfo.user,
        name: this.shoppingInfo.user.name,
        // phone: this.shoppingInfo.user.phone,
        mobile: this.shoppingInfo.user.phone,
        country_code: this.shoppingInfo.user.country_code,
        city: this.shoppingInfo.user.city,
        district: this.shoppingInfo.user.districts,
        address: this.shoppingInfo.user.address,
        zip_code: this.shoppingInfo.delivery.eGUIType === 0 && this.shoppingInfo.delivery.invoice_giving && this.shoppingInfo.delivery.invoice_donation ? this.shoppingInfo.delivery.invoice_donation : this.shoppingInfo.user.zip_code
      }

      axios.patch('/user/me', data)
        .then(() => {
          this.$store.dispatch('getProfile')
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}

export default updateMember
